var CurrentUser = require("lib/account/CurrentUser");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("notifications/slide_in_announcement.scss");

class SlideInAnnouncement extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        this.state = {
            hide: false,
            collapsed: false
        };
    }

    removeAlert() {
        CurrentUser.api().deleteUserAlert(this.props.alertID, () => {
            this.setState({ hide: true });
        });
    }

    toggle() {
        this.setState({ collapsed: !this.state.collapsed })
    }

    renderSlideInAnnouncement() {
        var arrowIcon = this.state.collapsed ? 'glyphicon glyphicon-chevron-left' : 'glyphicon glyphicon-chevron-right'


        return (
            <div className={`inner ${this.state.collapsed == true ? 'hideSidebar' : 'showSidebar'}`}>
                <div className="arrowContainer">
                    <Glyphicon icon={arrowIcon} className={`bodyArrow arrow`} onClick={this.toggle} />
                </div>
                <div className="bodyText">
                    {this.props.bodyContent}

                    <div className="removeContainer">
                        <Glyphicon icon={'remove'} className={'removeAlert'}
                            onClick={this.removeAlert} />
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (this.state.hide) { return null }
        
        return (
            <div key={this.props.alertID} className={`slideInAnnouncement ${this.state.collapsed == true ? 'hideSidebar' : 'showSidebar'}`}>
                {this.renderSlideInAnnouncement()}
            </div>
        );
    }
};

module.exports = SlideInAnnouncement;



// WEBPACK FOOTER //
// ./modules/components/notifications/SlideInAnnouncement.js